import { defineMessages } from 'react-intl';

export default defineMessages({
    manualCompanyText: {
        id: '_.manualCompany.search_for_company_name',
        defaultMessage: 'Please search for your company name'
    },
    registeredName: {
        id: '_.manualCompany.registered_name',
        defaultMessage: 'Registered name'
    },
    registeredNumber: {
        id: '_.manualCompany.registered_number',
        defaultMessage: 'Registered number'
    }
});
